import type { NavItem, NavLinkItem } from '../types/content';

export const company = {
  legalName: 'Liftoff Investments (Pty) Ltd',
  shortName: 'Liftoff Investments',
  registrationNumber: 'CO 2007/7072',
  incorporated: 'May 2007',
  incorporationAct: 'Companies Registration Act, Chapter 42:01',
  ownership: '100% citizen-owned',
  director: 'Obokeng Rabai',
  base: 'Gaborone, Botswana',
  descriptor: 'Civil / Structural & Mechanical Contractor',
  permanentEmployees: 14,
  casualEmployees: 'more than 100',
  footerDescription:
    'A citizen-owned Botswana construction company, incorporated in 2007, delivering roadworks, civil works, water and sanitation, and building and structural construction.',
};

export const contact = {
  siteUrl: 'https://liftoffinvestments.co.bw',
  email: 'info@liftoffinvestments.co.bw',
  legacyEmail: 'liftoffinvestments@yahoo.com',
  phone: { label: 'Telephone / Fax', display: '+267 395 4047', href: 'tel:+2673954047' },
  mobile: { label: 'Mobile', display: '+267 7165 4079', href: 'tel:+26771654079' },
  postal: 'P.O. Box 45721, Gaborone, Botswana',
  physical: 'Plot 2419, Extension 9, Gaborone',
};

export const contactReviewNotes = {
  email:
    'Confirm the info@liftoffinvestments.co.bw mailbox can send and receive before launch. The profile lists liftoffinvestments@yahoo.com.',
  address:
    'Plot 2419, Extension 9 is listed in the profile text, the back cover and both banners. The profile cover card lists Plot 22038, Unit 6, Gaborone West Industrial. Confirm which office is current.',
};

export const defaultShareImage =
  'https://cdn.magicpatterns.com/uploads/fsanPmVPrerXVXubCDnoRQ/Sunset_Excavators_on_a_Muddy_Worksite.png';

export const aboutLinks: NavLinkItem[] = [
  {
    label: 'Company Background',
    to: '/about/company-background',
    description: 'History, ownership and incorporation',
  },
  {
    label: 'Management & Technical Team',
    to: '/about/management-team',
    description: 'Engineers, project and site managers',
  },
  {
    label: 'Quality Assurance & Project Management',
    to: '/about/quality-project-management',
    description: 'How projects are planned and controlled',
  },
  {
    label: 'Registrations & Procurement',
    to: '/about/registrations-procurement',
    description: 'Company registration, PPADB codes and grades',
  },
];

export const mainNav: NavItem[] = [
  { label: 'Home', to: '/' },
  { label: 'About Us', to: '/about/company-background', children: aboutLinks },
  { label: 'Services', to: '/services' },
  { label: 'Projects', to: '/projects' },
  { label: 'Plant & Equipment', to: '/plant-equipment' },
  { label: 'Contact', to: '/contact' },
];

export const QUOTE_PATH = '/contact#enquiry';
